import { render, staticRenderFns } from "./icon-plus-button.component.vue?vue&type=template&id=767876d0&scoped=true&"
import script from "./icon-plus-button.component.vue?vue&type=script&lang=ts&"
export * from "./icon-plus-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./icon-plus-button.component.vue?vue&type=style&index=0&id=767876d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767876d0",
  null
  
)

export default component.exports